<script lang="ts" setup>
import type { VideoSectionRecord } from "~~/server/graphql/datocms/generated";

defineProps<{ data: VideoSectionRecord }>();
</script>

<template>
  <div class="gap-xl flex flex-col">
    <VideoBase v-for="video in data.videos" :key="video.id" :video="video" />
  </div>
</template>

<style scoped>

</style>
